<script>
    import { fly } from "svelte/transition";
    import { Divider } from '../index'
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础分割线</h4>
    <div class="example-body" style:background={"white"}>
       <Divider/>
    </div>
    <h4 class="example-title">带内容分割线</h4>
    <div class="example-body" style:background={"white"}>
       <Divider>居中分割线</Divider>
       <Divider contentPosition="left">左边</Divider>
       <Divider contentPosition="right">右边</Divider>
    </div>
    <h4 class="example-title">自定义样式分割线</h4>
    <div class="example-body" style:background={"white"}>
       <Divider --divider-color="red">自定义</Divider>
       <Divider --divider-color="red" --divider-text-color="red" --divider-style="dashed">自定义</Divider>
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
